import React from 'react';
import styles from './searchSuggestion.less';
import { HeadingText } from '@paypalcorp/pp-react';
import CategoryTiles from './categoryTiles/categoryTiles';
import CharityList from './charityList';

export default class extends React.Component {
  renderHeader = () => {
    return (
      <div className={styles['searchResultTile-text']}>
        {this.props.noSearchResult ? (
          <>
            <HeadingText style={{ marginBottom: '15px' }} size='md' regular>
              {this.props.i18n('label.noSearchResult')}
            </HeadingText>
            <HeadingText size='sm'>
              {this.props.i18n('label.charityRecommendTitle')}
            </HeadingText>
            {!this.props.showCategory && (
              <div className={styles.suggestCharityDivder} />
            )}
          </>
        ) : (
          <HeadingText as='h5' size='sm' regular>
            {this.props.i18n('label.charityRecommendTitle2')}
          </HeadingText>
        )}
      </div>
    );
  };
  renderTiles = () => {
    return (
      <div className={styles['searchResult-Tile']}>
        <CategoryTiles
          id={'charityCategories'}
          categories={this.props.categories}
          coBrand={this.props.coBrand}
          fptiInfo={this.props.fptiInfo}
          i18n={this.props.i18n} />
      </div>
    );
  };

  renderList = () => {
    return (
      <CharityList
        {...this.props}
        charities={this.props.suggestedCharties}
        fptiInfo={this.props.fptiInfo}
        i18n={this.props.i18n}
      />
    );
  };

  render() {
    return (
      <div className={styles['searchResultTile-container']}>
        {this.renderHeader()}
        {this.props.showCategory ? this.renderTiles() : this.renderList()}
      </div>
    );
  }
}
